declare global {
  interface Window {
    plausible?: (...args: any[]) => void;
  }
}

const plausible =
  typeof window !== "undefined" && window.plausible
    ? window.plausible
    : () => {};

export { plausible };
